import { relationshipSummaryModel } from '~/models';
const sortByCompanyName = (isVendor)=>(a, b)=>{
        const nameA = isVendor ? a.customer.name.toLowerCase() : a.vendor.name.toLowerCase();
        const nameB = isVendor ? b.customer.name.toLowerCase() : b.vendor.name.toLowerCase();
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    };
const sortById = (a, b)=>a.id < b.id ? -1 : 1;
const sortByEffectiveDate = (a, b)=>b.effectiveDate && a.effectiveDate && b.effectiveDate.getTime() - a.effectiveDate.getTime();
const sortByAssignee = (a, b)=>{
    const nameA = (relationshipSummaryModel.sellerFullName(a) || '').toLowerCase();
    const nameB = (relationshipSummaryModel.sellerFullName(b) || '').toLowerCase();
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};
export var HeaderColId = /*#__PURE__*/ function(HeaderColId) {
    HeaderColId["companyName"] = "companyName";
    HeaderColId["status"] = "status";
    HeaderColId["paymentMethod"] = "paymentMethod";
    HeaderColId["effectiveDate"] = "effectiveDate";
    HeaderColId["lastBilled"] = "lastBilled";
    HeaderColId["assignee"] = "assignee";
    return HeaderColId;
}({});
export const sortFunctions = {
    ["companyName"]: (param)=>{
        let { isAscending, isVendor } = param;
        return (a, b)=>{
            const retval = sortByCompanyName(isVendor)(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    },
    ["status"]: (param)=>{
        let { isAscending } = param;
        return (a, b)=>{
            const retval = sortByAgreementStatus(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    },
    ["lastBilled"]: (param)=>{
        let { isAscending } = param;
        return (a, b)=>{
            const retval = sortByLastBilledDate(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    },
    ["paymentMethod"]: (param)=>{
        let { isAscending } = param;
        return (a, b)=>{
            const retval = sortByPaymentMethod(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    },
    ["effectiveDate"]: (param)=>{
        let { isAscending } = param;
        return (a, b)=>{
            const retval = sortByEffectiveDate(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    },
    ["assignee"]: (param)=>{
        let { isAscending } = param;
        return (a, b)=>{
            const retval = sortByAssignee(a, b) || sortById(a, b);
            return isAscending ? -retval : retval;
        };
    }
};
const AD_HOC_STATUS_SORT_ORDER = 1;
const agreementStatusSortOrder = {
    [relationshipSummaryModel.AgreementStatus.Active]: 2,
    [relationshipSummaryModel.AgreementStatus.Exhausted]: 3,
    [relationshipSummaryModel.AgreementStatus.Terminated]: 4
};
function sortByLastBilledDate(a, b) {
    if (!a.lastBilledDate && !b.lastBilledDate) return 0;
    if (!a.lastBilledDate) return 1;
    if (!b.lastBilledDate) return -1;
    return b.lastBilledDate.getTime() - a.lastBilledDate.getTime();
}
function sortByAgreementStatus(a, b) {
    const aStatus = relationshipSummaryModel.agreementStatus(a);
    const bStatus = relationshipSummaryModel.agreementStatus(b);
    const aOrder = aStatus == null ? AD_HOC_STATUS_SORT_ORDER : agreementStatusSortOrder[aStatus];
    const bOrder = bStatus == null ? AD_HOC_STATUS_SORT_ORDER : agreementStatusSortOrder[bStatus];
    return aOrder - bOrder;
}
function sortByPaymentMethod(a, b) {
    return getPaymentMethodOrder(a.fundingSource) - getPaymentMethodOrder(b.fundingSource);
}
function getPaymentMethodOrder(pm) {
    if (!pm) return 5;
    if (pm.isCreditCard()) return 4;
    if (pm.isVerified()) return 3;
    if (pm.isPendingMicroDeposit()) return 2;
    // failed bankAccount
    return 1;
}
export function sortAgreements(config) {
    const { agreements, sort, isVendor, headerItems } = config;
    const result = agreements.slice();
    if (sort) {
        var _headerItems_sort_colIndex;
        const colId = (_headerItems_sort_colIndex = headerItems[sort.colIndex]) === null || _headerItems_sort_colIndex === void 0 ? void 0 : _headerItems_sort_colIndex.id;
        if (colId) {
            result.sort(sortFunctions[colId]({
                isVendor,
                isAscending: sort.sort === 'asc'
            }));
        }
    }
    return result;
}
